import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReferenceRangeContainer from './referenceRangeContainer';
import composeReference from '../xocs/references/composeReference';
import Icon from '../icon';
import PanelPaginationControls from '../sidebar/panelHeader/panelPaginationControls';
import PanelHeader from '../sidebar/panelHeader/panelHeader';
import { referenceType } from '../../../shared/constants';
import XocsType from '../xocs/xocsType';

export default class References extends Component {
  componentDidUpdate() {
    this.refPanel.scrollTop = 0;
  }

  render() {
    const {
      goToNext,
      goToPrev,
      hasNext,
      hasPrev,
      labels,
      reference,
      referencesCount,
    } = this.props;
    const { label, referenceList } = reference;
    const labelToShow = labels.length > 1
      ? `${labels[0].replace(']', '')}-${labels[labels.length - 1].replace('[', '')}`
      : label;

    return (
      <div className="reference-panel sidebar-scroll-panel sidebar-panel-default-appearance">
        <PanelHeader title={`References (${referencesCount})`}>
          <PanelPaginationControls
            hasNext={hasNext}
            hasPrev={hasPrev}
            goToNext={goToNext}
            goToPrev={goToPrev}
          />
        </PanelHeader>
        <div
          className="sidebar-scroll-panel-body"
          id="reference-panel"
          ref={(refPanel) => { this.refPanel = refPanel; }}
        >
          <div className="label">
            <Icon.CitedBy66 height={18} />
            <span>{labelToShow}</span>
          </div>
          <ReferenceRangeContainer labels={labels} referenceType={referenceType.bibliography} />
          {referenceList.map(ref => composeReference(ref))}
        </div>
      </div>
    );
  }
}

References.propTypes = {
  reference: PropTypes.shape({
    label: PropTypes.string,
    referenceList: PropTypes.arrayOf(XocsType),
  }).isRequired,
  goToNext: PropTypes.func.isRequired,
  goToPrev: PropTypes.func.isRequired,
  hasNext: PropTypes.bool.isRequired,
  hasPrev: PropTypes.bool.isRequired,
  labels: PropTypes.arrayOf(PropTypes.string),
  referencesCount: PropTypes.number.isRequired,
};

References.defaultProps = {
  labels: [],
};
